import { getAuth } from 'firebase/auth';

import {
  client,
  firebaseApp,
  getSubject,
  logout,
  useData,
  useSubject,
} from '@cold-ambulance/ui';

export const auth = getAuth(firebaseApp);

export async function getIdentity() {
  const subject = await getSubject(auth);
  if (!subject) {
    return null;
  }
  return client.request('GET /customer/me', {}).catch(async (error) => {
    await logout(auth).catch(() => {});
    console.error(error);
    throw error;
  });
}

export function useUser() {
  const subject = useSubject(auth);
  return useData(
    'GET /customer/me',
    {},
    { enabled: !!subject?.uid, staleTime: Infinity },
  );
}
